import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { config } from '../../config/jewelleryLandingConfig';
import SafeIcon from '../../common/SafeIcon';
import { FiPlus, FiMinus } from 'react-icons/fi';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-cream">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          {/* H2 for FAQ section */}
          <h2 className="text-4xl md:text-5xl text-espresso mb-6">Frequently Asked Questions</h2>
        </div>

        <div className="space-y-4">
          {config.faq.map((item, index) => (
            <div key={index} className="border-b border-champagne pb-4">
              <button 
                onClick={() => toggleFAQ(index)}
                className="w-full flex justify-between items-center py-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-mutedGold"
                aria-expanded={openIndex === index}
              >
                {/* H3 for each question */}
                <h3 className="font-serif text-xl text-espresso pr-8">{item.question}</h3>
                <SafeIcon 
                  icon={openIndex === index ? FiMinus : FiPlus} 
                  className="text-mutedGold flex-shrink-0 w-6 h-6" 
                />
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p className="font-light text-espresso/70 pb-6 leading-relaxed">
                      {item.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>

      {/* JSON-LD FAQPage Schema */}
      <script type="application/ld+json">
      {`
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": ${JSON.stringify(config.faq.map(item => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": item.answer
            }
          })))}
        }
      `}
      </script>
    </section>
  );
};

export default FAQ;